import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import UserService from '@/services/UserService';
import AccountService from '@/services/AccountService';
import { validationMixin, useSpinValidate } from '@/plugins/vuelidateCompat';
import { required, minLength } from '@vuelidate/validators';
import { bus } from '@/eventBus';
export default {
  data: () => {
    return {
      user: {
        password: null,
        password2: null
      },
      open: false,
      loading: false
    };
  },
  created() {
    this.init();
    // when user logs in, check again if we need a password change
    bus.$on('loggedIn', () => {
      this.init();
    });
  },
  methods: {
    init() {
      // check if the user is logged in and if the user needs a password change
      UserService.getUserInfo().then(result => {
        if (result && result.pwchange && result.pwchange === '1') {
          this.open = true;
        }
      }).catch(error => {
        this.$aim.error(error.response);
      });
    },
    submit() {
      this.loading = true;
      // check form validity
      if (this.$v.$invalid || this.$v.user.$anyError) {
        this.loading = false;
        this.$aim.error(null, 'warn', 'Error', 'Something is wrong in the form');
        return;
      }
      const data = {
        reset: {
          password: this.user.password
        }
      };

      // save the password change
      AccountService.savePwChange(data).then(() => {
        // refresh the user data after the password change
        UserService.refresh().then(refresh => {
          // set the local storage with the new refreshed data
          UserService.setStorage(refresh.data);
          // close the modal since it was successful
          this.open = false;
          // give the user a success message
          this.$aim.notify(null, 'info', 'Password Reset', 'You successfully reset your password');
        });
      }, error => {
        this.$aim.error(error.response);
      }).finally(() => {
        this.loading = false;
      });
    },
    getErrors: function (form, field, validators) {
      // get validation errors for each field
      const err = [];
      if (!this.$v[form][field].$dirty) return err;
      validators.forEach(e => {
        if (this.$v[form][field][e].$invalid) {
          e === 'required' && err.push('This field is required');
          e === 'sameAsPassword' && err.push('Passwords do not match');
          e === 'minLength' && err.push(field.capitalize() + ' must be at least ' + this.$v[form][field].minLength.$params.min + ' characters');
        }
      });
      return err;
    }
  },
  mixins: [validationMixin],
  setup() {
    return useSpinValidate();
  },
  validations: {
    user: {
      password: {
        required,
        minLength: minLength(6)
      },
      password2: {
        required,
        // Vuelidate 2 sameAs() compares to a value, not a field name
        sameAsPassword: (value, siblings) => value === siblings.password
      }
    }
  }
};